import { render, staticRenderFns } from "./TextAreaCellRenderer.vue?vue&type=template&id=2d3a77a1&scoped=true&lang=pug&"
import script from "./TextAreaCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./TextAreaCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaCellRenderer.vue?vue&type=style&index=0&id=2d3a77a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a77a1",
  null
  
)

export default component.exports